import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productEdition, productImage, productImageAlt, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-[#0A1B33]" data-id="element-85" data-mp="s9gfzxf9kc74">
      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-86" data-mp="nb6llp1d5fmk">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white sm:text-sm" data-id="element-87" data-mp="3d1sbr0oqzpup">
          <ZapIcon className="h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" data-id="element-88" data-mp="3o6aqnxwkkb10" /> {productBrand} · {productEdition}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-89" data-mp="39cpc2rohrf1b">
          <img src={productImage} alt={productImageAlt} className="mockup-glow mx-auto w-full" data-id="element-90" data-mp="35aasu6gwud9i" />
        </motion.div>

        <div className="mt-9" data-id="element-91" data-mp="2qhqvxnkct20i">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-92" data-mp="2viojygs1oq9x">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-200" data-id="element-93" data-mp="2hjym2yxeimki">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-94" data-mp="s3mcu1g2bwxu">
              <Icon className="h-4 w-4 text-teal-300" aria-hidden="true" data-id="element-95" data-mp="nb1o3ec0ka16" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}